import React from 'react';
import { Helmet } from 'react-helmet-async';
import {
    DEFAULT_DESCRIPTION,
    SITE_ADDRESS,
    SITE_AGGREGATE_RATING,
    SITE_GEO,
    SITE_METRO_NEARBY,
    SITE_NAME,
    SITE_URL,
} from '../../config/seo';

const LocalBusinessJsonLd = () => {
    const schema = {
        '@context': 'https://schema.org',
        '@type': 'HairSalon',
        name: SITE_NAME,
        url: SITE_URL,
        image: `${SITE_URL}/og-image.png`,
        description: DEFAULT_DESCRIPTION,
        telephone: '+7-915-189-70-33',
        email: 'salon.l.e.v@yandex.ru',
        address: {
            '@type': 'PostalAddress',
            streetAddress: SITE_ADDRESS.streetAddress,
            addressLocality: SITE_ADDRESS.addressLocality,
            postalCode: SITE_ADDRESS.postalCode,
            addressCountry: SITE_ADDRESS.addressCountry,
        },
        geo: {
            '@type': 'GeoCoordinates',
            latitude: SITE_GEO.latitude,
            longitude: SITE_GEO.longitude,
        },
        hasMap: 'https://yandex.ru/maps/org/salon_l_e_v/117473602162/',
        aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: SITE_AGGREGATE_RATING.ratingValue,
            reviewCount: SITE_AGGREGATE_RATING.reviewCount,
            bestRating: SITE_AGGREGATE_RATING.bestRating,
            worstRating: SITE_AGGREGATE_RATING.worstRating,
        },
        areaServed: [
            { '@type': 'City', name: 'Москва' },
            ...SITE_METRO_NEARBY.map((name) => ({
                '@type': 'Place',
                name,
            })),
        ],
        openingHoursSpecification: [
            {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: [
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday',
                    'Sunday',
                ],
                opens: '10:00',
                closes: '21:00',
            },
        ],
        priceRange: '₽₽',
        inLanguage: 'ru-RU',
    };

    return (
        <Helmet>
            <meta name="geo.region" content="RU-MOW" />
            <meta name="geo.placename" content="Москва, метро Смоленская" />
            <meta
                name="geo.position"
                content={`${SITE_GEO.latitude};${SITE_GEO.longitude}`}
            />
            <meta name="ICBM" content={`${SITE_GEO.latitude}, ${SITE_GEO.longitude}`} />
            <script type="application/ld+json">{JSON.stringify(schema)}</script>
        </Helmet>
    );
};

export default LocalBusinessJsonLd;
